import { render, staticRenderFns } from "./ButtonLinkForward.vue?vue&type=template&id=39c32042&scoped=true"
import script from "./ButtonLinkForward.vue?vue&type=script&lang=js"
export * from "./ButtonLinkForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c32042",
  null
  
)

export default component.exports